/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  let links = document.links;
  let linksLength = links.length
  for (let i = 0; i < linksLength; i++) {
    if (links[i].pathname.includes("_blank")) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
 

  $(function() {
   $("ul.shopify-tabs > li").click(function() {
      // remove classes from all
      $("li").removeClass("current");
      // add class to the one we clicked
      $(this).addClass("current");
   });
});

  // ---- V2 Search: Force filter drawer toggle on all screen sizes ----
  if (document.body.classList.contains('template-search')) {
    document.querySelectorAll('[data-toggle-filters]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var filters = document.querySelector('.collection__filters');
        if (!filters) return;
        filters.classList.toggle('collection__filters--visible');
        document.body.classList.toggle('has-filters-open');
      });
    });
    document.querySelectorAll('[data-close-filters]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var filters = document.querySelector('.collection__filters');
        if (filters) filters.classList.remove('collection__filters--visible');
        document.body.classList.remove('has-filters-open');
      });
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
